import { storage } from "../../../utils/storage";
import { Domain } from "../models/Domain";

const DOMAIN_KEY = "selectedDomain";

export const domainStorage = {
  set(domain: Domain) {
    storage.set(DOMAIN_KEY, domain);
    window.dispatchEvent(new Event("domain-storage-changed"));
  },

  get(): Domain | null {
    return storage.get<Domain>(DOMAIN_KEY);
  },

  clear() {
    storage.remove(DOMAIN_KEY);
    window.dispatchEvent(new Event("domain-storage-changed"));
  },

  getId(): string | null {
    const domain = domainStorage.get();
    return domain?.id?.toString() ?? null;
  },

  isSelected(id: string | number): boolean {
    return domainStorage.getId() === id.toString();
  },
};